import type { LoteArbitralResumo } from '../types/loteArbitralTypes';
import type { ProcessoArbitralListItemDto } from '../types/processosArbitraisStoreTypes';

const PROCESSOS_KEY = 'arbitral.lote.processos';
const LOTES_KEY = 'arbitral.lote.resumos';

const readList = <T>(key: string): T[] => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.sessionStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as T[]) : [];
  } catch {
    return [];
  }
};

const writeList = <T>(key: string, value: T[]): void => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // sessionStorage indisponível — mock apenas em memória nesta sessão
  }
};

export const getMockProcessosArbitrais = (): ProcessoArbitralListItemDto[] =>
  readList<ProcessoArbitralListItemDto>(PROCESSOS_KEY);

export const getMockLotesArbitrais = (): LoteArbitralResumo[] =>
  readList<LoteArbitralResumo>(LOTES_KEY);

export const persistMockLoteArbitral = (
  processos: ProcessoArbitralListItemDto[],
  resumo: LoteArbitralResumo,
): void => {
  writeList(PROCESSOS_KEY, [...processos, ...getMockProcessosArbitrais()]);
  writeList(LOTES_KEY, [resumo, ...getMockLotesArbitrais()]);
};
